import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

// Models.
import { AuthInfo, AuthReq } from '../models/authObjects';

// Tikis.
import { Api } from '../common/constants/api';
import { ServerResponse } from '../models/RES/serverResponse';

@Injectable({
    providedIn: 'root'
})
export class ServiceTypesService {
  constructor(
    private _http: HttpClient
  ) {}

  url: string = Api.ServiceType;

  public GetAllServiceTypes(): Observable<ServerResponse> {
    return this._http.get<ServerResponse>(`${this.url}/GetAllServiceTypes`);
  }

  public GetServiceTypesByCognitoUser(): Observable<ServerResponse> {
    return this._http.get<ServerResponse>(`${this.url}/GetServiceTypesByCognitoUser`);
  }
}